import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserThemeRepositoryImpl } from "../../data/repository/user_theme_repository_impl";
import { StartThemeInterface } from "../interface/start_theme_interface";
import { UserThemeInterface } from "../interface/user_theme_interface";

export const useStartTheme = () => {
  const repository = new UserThemeRepositoryImpl();
  const queryClient = useQueryClient();

  return useMutation<UserThemeInterface, Error, StartThemeInterface>({
    mutationFn: (data: StartThemeInterface) => repository.startTheme(data),
    onSuccess: (response) => {
        const themeId = typeof response._themeId === 'string' ? response._themeId : response._themeId!._id;
        queryClient.invalidateQueries({ queryKey: ['useGetUserAnswers', themeId, response._userId] });
    }
  });
};